var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "fade", duration: "350" } }, [
        !_vm.buildings.isLoading & (_vm.buildings.list.length == 0)
          ? _c("div", { staticClass: "catalog-layout__content_empty" }, [
              _c("p", [_vm._v("Нет результатов")])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "masonryGrid", staticClass: "catalog-masonry" },
        [
          _c("div", { staticClass: "catalog-masonry__sizer" }),
          _vm._v(" "),
          _c("div", { staticClass: "catalog-masonry__gutter" }),
          _vm._v(" "),
          _c(
            "transition-group",
            {
              attrs: { name: "fade", duration: "300" },
              on: { "after-leave": _vm.updateMasonry }
            },
            _vm._l(_vm.buildings.list, function(item, index) {
              return _c(
                "div",
                { key: item.title, staticClass: "catalog-grid-item" },
                [
                  _c("div", { staticClass: "img" }, [
                    _c("img", {
                      attrs: { src: item.thumbnail, alt: item.title }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(item.title))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "metro" }, [
                      _c("i", {
                        style: { "background-color": item.metro.color }
                      }),
                      _vm._v(_vm._s(item.metro.title))
                    ]),
                    _vm._v(" "),
                    item.meterPrice && item.meterPrice > 0
                      ? _c("span", { staticClass: "price" }, [
                          _vm._v(
                            "от " +
                              _vm._s(_vm._f("threeDigits")(item.meterPrice)) +
                              " руб/м"
                          ),
                          _c("sup", [_vm._v("2")])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("a", { staticClass: "link", attrs: { href: item.url } })
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", duration: "350" } }, [
        _vm.buildings.total > _vm.buildings.list.length
          ? _c("div", { staticClass: "catalog-masonry__foot" }, [
              _c(
                "span",
                {
                  staticClass: "button-pill",
                  class: { loading: _vm.buildings.isLoading },
                  on: {
                    click: function($event) {
                      return _vm.$parent.getNextPage()
                    }
                  }
                },
                [_vm._v("Загрузить еще")]
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }